import { Component, Input } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { RouterLink, RouterLinkActive } from "@angular/router";

import { FeatureHighlightDirective } from "../feature-highlight/feature-highlight.directive";
import { FeatureHighlightKey } from "../feature-highlight/feature-highlight.model";

@Component({
    selector: "bottom-navigation",
    imports: [MatIcon, RouterLink, RouterLinkActive, FeatureHighlightDirective],
    templateUrl: "./bottom-navigation.html",
    styleUrl: "./bottom-navigation.scss"
})
export class BottomNavigation {
    @Input() public menuItems: { label: string; icon: string; route: string; id?: string; featureHighlight?: FeatureHighlightKey }[] = [];
}
